import DOMPurify from "dompurify";

/**
 * Safely renders a small subset of markdown (h1-h3, bold, line breaks)
 * to HTML, sanitised through DOMPurify so user / LLM-generated content
 * cannot execute scripts.
 */
const escapeHtml = (s = "") =>
  s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const renderMarkdown = (raw) => {
  if (!raw) return "";
  // Escape FIRST so any HTML inside the source is rendered as text, not executed
  let html = escapeHtml(raw);
  html = html
    .replace(/^### (.*)$/gm, "<h3>$1</h3>")
    .replace(/^## (.*)$/gm, "<h2>$1</h2>")
    .replace(/^# (.*)$/gm, "<h1>$1</h1>")
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
    .replace(/\n/g, "<br/>");
  return html;
};

export const SafeMarkdown = ({ content, className = "", testId }) => {
  const sanitized = DOMPurify.sanitize(renderMarkdown(content), {
    ALLOWED_TAGS: ["h1", "h2", "h3", "strong", "br", "p", "em", "ul", "ol", "li"],
    ALLOWED_ATTR: [],
  });
  return (
    <div
      className={className}
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};

export default SafeMarkdown;
